// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Nav_logoWrapper__-knH7"};